<ng-container *ngIf="isSsoNoAccess; else featureDenied">
  <app-status-message
    [title]="constants.ssoNoAccessTitle"
    [message]="constants.ssoNoAccessMessage"
  />
  <div class="flex justify-center mb-12">
    <thera-button
      [config]="{ variant: buttonVariant.PRIMARY, text: constants.tryDifferentAccount }"
      (click)="tryDifferentAccount()"
    ></thera-button>
  </div>
</ng-container>
<ng-template #featureDenied>
  <a [routerLink]="previousUrl">Return to previous</a>
  <app-status-message/>
</ng-template>